module.exports = __webpack_public_path__ + "static/media/Montserrat-BoldItalic.b8f5b73d.eot";